
import { supabase } from "@/integrations/supabase/client";
import { Reagent } from "@/types/reagent.types";
import { createLogger } from "../utils/loggingUtils";
import { toast } from "sonner";
import { mapReagentArray } from "../utils/reagentMapper";

const logger = createLogger('fetchUserReagents');

export const fetchUserReagents = async (userId: string): Promise<Reagent[]> => {
  try {
    logger.info(`Fetching reagents for user: ${userId}`);
    
    const { data, error } = await supabase
      .from("reagents")
      .select(`
        *,
        profiles:user_id(*),
        categories:category_id(*)
      `)
      .eq("user_id", userId)
      .eq("available", true);

    if (error) {
      logger.error("Error fetching user reagents:", error);
      toast.error("Failed to load user reagents");
      return [];
    }

    // Transform data to match the Reagent type using the shared mapper
    const reagents = mapReagentArray(data);
    
    logger.info(`Successfully fetched ${reagents.length} reagents for user ${userId}`);
    return reagents;
  } catch (error) {
    logger.error("Exception fetching user reagents:", error);
    toast.error("An unexpected error occurred");
    return [];
  }
};
